import { createFileRoute } from "@tanstack/react-router";

import type { AlternateLocale } from "@/features/blog/locales";
import { loadBlogPostPage } from "@/features/blog/load-blog-post-detail";
import { buildBlogPostHead } from "@/features/blog/route-data";
import { BlogDetailScreen } from "@/features/blog/screens/BlogDetailScreen";

export const Route = createFileRoute("/_landing/$locale/blog/$slug")({
  loader: ({ params }) =>
    loadBlogPostPage(params.locale as AlternateLocale, params.slug),
  head: ({ loaderData, params }) => {
    return buildBlogPostHead({
      loaderData,
      locale: (loaderData?.locale ?? params.locale) as AlternateLocale,
    });
  },
  component: LocalizedBlogPostRoute,
});

function LocalizedBlogPostRoute() {
  return <BlogDetailScreen data={Route.useLoaderData()} />;
}
